import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import MenubarUser from "../../layouts/MenubarUser";
import { getOrders } from "../../function/users";
import Invoice from "../../page/user/Invoice";
import InvoiceJsPDF from "../../order/invoiceJsPDF";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Pagination } from "antd";
import {
  CheckCircleOutlined,
  SyncOutlined,
  CloseOutlined,
  ClockCircleOutlined,
  FilePdfOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import "./History.css";

const History = () => {
  const { user } = useSelector((state) => ({ ...state }));
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 10;

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    getOrders(user.token).then((res) => setOrders(res.data));
  };

  const getStatusConfig = (status) => {
    switch (status) {
      case "Processing":
        return { label: "กำลังดำเนินการ", className: "status-processing", icon: <SyncOutlined spin /> };
      case "Completed":
        return { label: "เสร็จสมบูรณ์", className: "status-completed", icon: <CheckCircleOutlined /> };
      case "Cancelled":
        return { label: "ยกเลิกแล้ว", className: "status-cancelled", icon: <CloseOutlined /> };
      default:
        return { label: status, className: "status-default", icon: <ClockCircleOutlined /> };
    }
  };

  const indexOfLast = currentPage * ordersPerPage;
  const indexOfFirst = indexOfLast - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirst, indexOfLast);

  return (
    <div className="order-page">
      <div className="order-layout">
        <div className="order-sidebar">
          <MenubarUser />
        </div>

        <div className="order-main">
          <div className="order-page-header">
            <h4 className="order-page-title">ประวัติการสั่งซื้อ</h4>
            <span className="order-count-badge">{orders.length} รายการ</span>
          </div>

          {currentOrders.length === 0 ? (
            <div className="order-empty">
              <ClockCircleOutlined className="order-empty-icon" />
              <p>ยังไม่มีประวัติการสั่งซื้อ</p>
            </div>
          ) : (
            <div className="order-list">
              {currentOrders.map((item, index) => {
                const statusConfig = getStatusConfig(item.orderstatus);
                return (
                  <div key={index} className="order-card">
                    {/* Header */}
                    <div className="order-card-header">
                      <div className="order-card-left">
                        <span className={`order-status-badge ${statusConfig.className}`}>
                          {statusConfig.icon}
                          {statusConfig.label}
                        </span>
                        <span className="order-number">
                          #{item.orderNumber || "ไม่มีหมายเลข"}
                        </span>
                      </div>
                    </div>

                    {/* Table */}
                    <div className="order-table-wrap">
                      <table className="order-table">
                        <thead>
                          <tr>
                            <th>ชื่อสินค้า</th>
                            <th>ราคา</th>
                            <th>จำนวน</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.products.map((p, i) => (
                            <tr key={i}>
                              <td>{p.product?.title || "ไม่มีข้อมูลสินค้า"}</td>
                              <td>
                                {Number(p.price).toLocaleString("th-TH", {
                                  minimumFractionDigits: 2,
                                })}{" "}
                                บาท
                              </td>
                              <td>{p.count}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Summary */}
                    <div className="order-summary">
                      {item.pointsDiscount > 0 && (
                        <div className="order-summary-row discount">
                          <span>ส่วนลดแต้มสะสม ({item.pointsUsed} แต้ม)</span>
                          <span>−{item.pointsDiscount} บาท</span>
                        </div>
                      )}
                      {item.couponDiscount > 0 && (
                        <div className="order-summary-row discount">
                          <span>คูปอง {item.couponCode || ""}</span>
                          <span>
                            −{Math.floor(item.cartTotal * (item.couponDiscount / 100))} บาท
                          </span>
                        </div>
                      )}
                      <div className="order-summary-row total">
                        <span>ยอดรวมสุทธิ</span>
                        <span>
                          {Number(item.cartTotal).toLocaleString("th-TH", {
                            minimumFractionDigits: 2,
                          })}{" "}
                          บาท
                        </span>
                      </div>
                    </div>

                    {/* Footer - Download buttons */}
                    <div className="order-card-footer history-footer">
                      {item.orderdBy?.address ? (
                        <PDFDownloadLink
                          document={<Invoice order={item} />}
                          fileName={`invoice-${item.orderNumber || index}.pdf`}
                          className="btn-download"
                        >
                          {({ loading }) => (
                            <>
                              <FilePdfOutlined />
                              {loading ? "กำลังโหลด..." : "ดาวน์โหลด PDF"}
                            </>
                          )}
                        </PDFDownloadLink>
                      ) : (
                        <span className="no-address-hint">ไม่มีข้อมูลที่อยู่</span>
                      )}
                      <span className="btn-download btn-download-js">
                        <InvoiceJsPDF order={item} />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div className="order-pagination">
            <Pagination
              current={currentPage}
              total={orders.length}
              pageSize={ordersPerPage}
              onChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;